import { apiClient } from "./ApiClient";

export const retrieveBatchAllocationsByShippingInstructionApi = (shippingInstructionId) =>
  apiClient.get(`/api/shipping-instructions/${shippingInstructionId}/batch-allocations`);

export const deAllocateBatchAllocationApi = (shippingInstructionId, allocationId) =>
  apiClient.delete(`/api/shipping-instructions/${shippingInstructionId}/batch-allocations/${allocationId}`);

export const retrieveAllocationsByBatchApi = (batchId) =>
  apiClient.get(`/api/batches/${batchId}/allocations`);

export const retrieveBatchAllocationCountsBySiApi = (siIds) =>
  apiClient.post(`/api/batch-allocations/si-counts`, siIds);
